var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 380,
    viewBox: "0 0 433 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16304 0V377.996",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 188.417L430 188.417",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430 0.00354004V378",
    stroke: "white",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.109 0.00354004V378",
    stroke: "white",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.217 0.00354004V378",
    stroke: "white",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5647 63.9709V29.0796C34.5647 -3.48554 112.489 0.00358677 112.489 29.0796V63.9709L126.445 67.46C130.343 69.8137 130.724 71.306 126.445 74.4383H112.489C112.489 74.4383 117.486 130.89 112.489 151.199C107.491 171.509 41.1301 172.778 34.5647 151.199C27.9993 129.621 34.5647 74.4383 34.5647 74.4383H21.7712C18.7153 71.7131 18.9893 70.1852 21.7712 67.46C24.553 64.7348 34.5647 63.9709 34.5647 63.9709Z",
    fill: "#2B2B2B",
    stroke: "#2B2B2B",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8697 59.3221C67.9003 51.4423 81.1014 51.687 104.348 59.3221L96.2066 73.2786C78.9625 71.4235 69.2551 71.3847 52.011 73.2786L43.8697 59.3221Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1956 141.895C70.2263 149.775 81.1013 149.53 104.348 141.895L92.7174 130.264C75.4733 132.12 72.7441 132.158 55.5 130.264L46.1956 141.895Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2174 74.4384L50.8478 86.0689V117.471L39.2174 125.612V74.4384Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109 125.612L97.3696 113.982V82.5797L109 74.4384V125.612Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8461 30.7706C43.1722 23.7924 50.1503 19.1402 54.8024 17.9772C59.4546 16.8141 61.7807 20.3032 60.6178 24.9554C59.4549 29.6076 52.4766 36.5858 47.8242 37.7489C43.1718 38.912 38.52 37.7489 40.8461 30.7706Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.78 30.7706C104.453 23.7924 97.4754 19.1402 92.8232 17.9772C88.171 16.8141 85.8449 20.3032 87.0078 24.9554C88.1708 29.6076 95.149 36.5858 99.8014 37.7489C104.454 38.912 109.106 37.7489 106.78 30.7706Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.7 65.007V30.1157C321.7 -2.44941 399.624 1.03972 399.624 30.1157V65.007L413.581 68.4962C417.478 70.8498 417.859 72.3421 413.581 75.4744H399.624C399.624 75.4744 404.622 131.926 399.624 152.235C394.626 172.545 328.265 173.814 321.7 152.235C315.135 130.657 321.7 75.4744 321.7 75.4744H308.907C305.851 72.7492 306.125 71.2214 308.907 68.4962C311.688 65.771 321.7 65.007 321.7 65.007Z",
    fill: "#2B2B2B",
    stroke: "#2B2B2B",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.005 60.3582C355.036 52.4784 368.237 52.7231 391.483 60.3582L383.342 74.3147C366.098 72.4596 356.391 72.4208 339.146 74.3147L331.005 60.3582Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.331 142.931C357.362 150.811 368.237 150.566 391.483 142.931L379.853 131.301C362.609 133.156 359.88 133.194 342.635 131.301L333.331 142.931Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M326.353 75.4745L337.983 87.105V118.507L326.353 126.648V75.4745Z",
    fill: "#E5E5E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M396.135 126.648L384.505 115.018V83.6158L396.135 75.4745V126.648Z",
    fill: "#E5E5E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M327.982 31.8068C330.308 24.8285 337.286 20.1763 341.938 19.0133C346.59 17.8503 348.916 21.3394 347.753 25.9916C346.59 30.6438 339.612 37.622 334.96 38.785C330.307 39.9481 325.655 38.7851 327.982 31.8068Z",
    fill: "#E5E5E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M393.915 31.8068C391.589 24.8285 384.611 20.1763 379.959 19.0133C375.307 17.8503 372.98 21.3394 374.143 25.9916C375.306 30.6438 382.284 37.622 386.937 38.785C391.589 39.9481 396.241 38.7851 393.915 31.8068Z",
    fill: "#E5E5E5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255.122 109.922V144.813C255.122 177.378 177.198 173.889 177.198 144.813V109.922L163.242 106.433C159.344 104.079 158.963 102.587 163.242 99.4544H177.198C177.198 99.4544 172.2 43.0027 177.198 22.6934C182.196 2.38409 248.557 1.11487 255.122 22.6934C261.688 44.272 255.122 99.4544 255.122 99.4544H267.916C270.972 102.18 270.697 103.707 267.916 106.433C265.134 109.158 255.122 109.922 255.122 109.922Z",
    fill: "#14213D",
    stroke: "#14213D",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M245.817 114.571C221.787 122.45 208.585 122.206 185.339 114.571L193.48 100.614C210.724 102.469 220.432 102.508 237.676 100.614L245.817 114.571Z",
    fill: "#E5E5E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M243.491 31.9978C219.46 24.118 208.585 24.3626 185.339 31.9978L196.969 43.6282C214.214 41.7731 216.943 41.7343 234.187 43.6282L243.491 31.9978Z",
    fill: "#E5E5E5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M250.469 99.4543L238.839 87.8238V56.4217L250.469 48.2804V99.4543Z",
    fill: "#E5E5E5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M180.687 48.2804L192.317 59.9108V91.313L180.687 99.4543V48.2804Z",
    fill: "#E5E5E5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.841 143.122C246.515 150.1 239.536 154.752 234.884 155.916C230.232 157.079 227.906 153.589 229.069 148.937C230.232 144.285 237.21 137.307 241.863 136.144C246.515 134.981 251.167 136.144 248.841 143.122Z",
    fill: "#E5E5E5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.907 143.122C185.233 150.1 192.211 154.752 196.864 155.916C201.516 157.079 203.842 153.589 202.679 148.937C201.516 144.285 194.538 137.307 189.885 136.144C185.233 134.981 180.581 136.144 182.907 143.122Z",
    fill: "#E5E5E5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5925 320.306V355.197C35.5925 387.762 113.516 384.273 113.516 355.197V320.306L127.473 316.817C131.371 314.463 131.752 312.971 127.473 309.838H113.516C113.516 309.838 118.514 253.387 113.516 233.077C108.519 212.768 42.1579 211.499 35.5925 233.077C29.0271 254.656 35.5925 309.838 35.5925 309.838H22.7991C19.7431 312.564 20.0172 314.091 22.7991 316.817C25.5809 319.542 35.5925 320.306 35.5925 320.306Z",
    fill: "#14213D",
    stroke: "#14213D",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8976 324.955C68.9282 332.834 82.1293 332.59 105.376 324.955L97.2345 310.998C79.9904 312.853 70.283 312.892 53.0389 310.998L44.8976 324.955Z",
    fill: "#E5E5E5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2235 242.382C71.2542 234.502 82.1292 234.747 105.376 242.382L93.7453 254.012C76.5012 252.157 73.772 252.118 56.5279 254.012L47.2235 242.382Z",
    fill: "#E5E5E5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2453 309.838L51.8757 298.208V266.806L40.2453 258.664V309.838Z",
    fill: "#E5E5E5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M110.028 258.664L98.3975 270.295V301.697L110.028 309.838V258.664Z",
    fill: "#E5E5E5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.874 353.506C44.2001 360.484 51.1782 365.136 55.8303 366.299C60.4825 367.463 62.8086 363.973 61.6457 359.321C60.4828 354.669 53.5045 347.691 48.8521 346.528C44.1996 345.365 39.5478 346.528 41.874 353.506Z",
    fill: "#E5E5E5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M107.807 353.506C105.481 360.484 98.5033 365.136 93.8511 366.299C89.1989 367.463 86.8728 363.973 88.0357 359.321C89.1987 354.669 96.1769 347.691 100.829 346.528C105.482 345.365 110.134 346.528 107.807 353.506Z",
    fill: "#E5E5E5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M322.728 319.27V354.161C322.728 386.726 400.652 383.237 400.652 354.161V319.27L414.608 315.781C418.506 313.427 418.887 311.935 414.608 308.802H400.652C400.652 308.802 405.65 252.351 400.652 232.041C395.654 211.732 329.293 210.463 322.728 232.041C316.163 253.62 322.728 308.802 322.728 308.802H309.935C306.879 311.527 307.153 313.055 309.935 315.781C312.716 318.506 322.728 319.27 322.728 319.27Z",
    fill: "#14213D",
    stroke: "#14213D",
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M332.033 323.918C356.064 331.798 369.265 331.554 392.511 323.918L384.37 309.962C367.126 311.817 357.418 311.856 340.174 309.962L332.033 323.918Z",
    fill: "#E5E5E5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M334.359 241.346C358.39 233.466 369.265 233.711 392.511 241.346L380.881 252.976C363.637 251.121 360.907 251.082 343.663 252.976L334.359 241.346Z",
    fill: "#E5E5E5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M327.381 308.802L339.011 297.172V265.769L327.381 257.628V308.802Z",
    fill: "#E5E5E5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M397.163 257.628L385.533 269.259V300.661L397.163 308.802V257.628Z",
    fill: "#E5E5E5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M329.009 352.47C331.336 359.448 338.314 364.1 342.966 365.263C347.618 366.426 349.944 362.937 348.781 358.285C347.618 353.633 340.64 346.655 335.988 345.492C331.335 344.329 326.683 345.492 329.009 352.47Z",
    fill: "#E5E5E5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M394.943 352.47C392.617 359.448 385.639 364.1 380.987 365.263C376.334 366.426 374.008 362.937 375.171 358.285C376.334 353.633 383.312 346.655 387.965 345.492C392.617 344.329 397.269 345.492 394.943 352.47Z",
    fill: "#E5E5E5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M256.15 274.355V239.464C256.15 206.898 178.226 210.388 178.226 239.464V274.355L164.27 277.844C160.372 280.198 159.991 281.69 164.27 284.822H178.226C178.226 284.822 173.228 341.274 178.226 361.583C183.224 381.893 249.585 383.162 256.15 361.583C262.715 340.005 256.15 284.822 256.15 284.822H268.943C271.999 282.097 271.725 280.569 268.943 277.844C266.162 275.119 256.15 274.355 256.15 274.355Z",
    fill: "#2B2B2B",
    stroke: "#2B2B2B",
    strokeWidth: 3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M246.845 269.706C222.814 261.826 209.613 262.071 186.367 269.706L194.508 283.663C211.752 281.807 221.459 281.769 238.704 283.663L246.845 269.706Z",
    fill: "#E5E5E5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M244.519 352.279C220.488 360.159 209.613 359.914 186.367 352.279L197.997 340.648C215.241 342.504 217.97 342.542 235.215 340.648L244.519 352.279Z",
    fill: "#E5E5E5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M251.497 284.822L239.867 296.453V327.855L251.497 335.996V284.822Z",
    fill: "#E5E5E5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181.715 335.996L193.345 324.366V292.964L181.715 284.822V335.996Z",
    fill: "#E5E5E5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M249.869 241.155C247.542 234.176 240.564 229.524 235.912 228.361C231.26 227.198 228.934 230.687 230.097 235.339C231.26 239.992 238.238 246.97 242.89 248.133C247.543 249.296 252.195 248.133 249.869 241.155Z",
    fill: "#E5E5E5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.935 241.155C186.261 234.176 193.239 229.524 197.891 228.361C202.544 227.198 204.87 230.687 203.707 235.339C202.544 239.992 195.566 246.97 190.913 248.133C186.261 249.296 181.609 248.133 183.935 241.155Z",
    fill: "#E5E5E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLot);
export default __webpack_public_path__ + "static/media/Lot.16c1ac16ec3c8bcdd6647cf6d319250f.svg";
export { ForwardRef as ReactComponent };